export enum PickerSymbolType {
    Digit,
    Symbols,
    Clear,
}
